export default __webpack_public_path__ + "static/media/output.a5ca787a.webm";